import { Component, Input, OnChanges } from '@angular/core';
import { SetComponentsService } from '../../../services/edit/set-components.service';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { LayoutService } from '../../../services/layout.service';
import { SidenavContent } from '../../side-nav/sidenav-content';

@Component({
  selector: 'edit-c-feedback',
  templateUrl: './edit-c-feedback.component.html',
  styleUrls: ['./edit-c-feedback.component.scss'],
})
export class EditCFeedbackComponent extends SidenavContent implements OnChanges {
  @Input() feed: any;
  @Input() template: any;
  @Input() rowType: any;
  @Input() rowArray: any;
  @Input() compArray: any;
  @Input() edit: boolean;

  isCollapsed = true;
  title: string;
  background = '';
  color = '';
  flushed: boolean;
  emailCheckbox: boolean;
  inputBack = '#fafafa';
  labelColor: any = 'var(--link)';
  name = true;
  phone = true;
  email: any;
  sendButton: any;
  resetButton: any;
  placeholder: any;
  sendEmail: any = [];
  subjectLine: any;
  optionalTxt: any;

  private _temp: any;
  private _OneColumn: boolean;
  private _TwoColumns: boolean;
  private _ThreeColumns: boolean;
  private _FourColumns: boolean;
  private _FiveColumns: boolean;
  private _SixColumns: boolean;

  private typeOf = 'feedback';
  private className: string;
  private enableReset = true;
  private sendLabel: string;
  private replyChecked: boolean; // display for reply email
  private emailOptional = true;
  private btnClass: any;
  private replyOption: any;
  private desc: any;

  constructor(
    private _editService: SetComponentsService,
    private _layoutService: LayoutService,
    private _snackBar: MatSnackBar,
  ) {
    super(_layoutService);
  }

  ngOnChanges() {
    this.setRowType();
    this._temp = this.template;
    // check Input() edit to pass in variables or set new variables.
    if (this.edit === true) {
      this.setRowType();
      this.getFormVariables();
    } else {
      this.setNewVariables();
    }
  }

  setNewVariables() {
    switch (this.rowType) {
      case 'col-2':
        //this.TwoColumns=true;
        this.className = 'height-250 padding-0-10';
        this.title = 'Send Your Feedback';
        this.sendButton = 'Submit';
        this.placeholder = 'Write us a message...';
        this.background = '';
        this.color = '';
        this.flushed = true;
        this.enableReset = false;
        this.sendLabel = '';
        //this.inputColor = '';
        this.inputBack = '';
        this.labelColor = '';
        this.replyChecked = false;
        this.emailCheckbox = true;
        this.sendEmail = '';
        this.replyOption = '';
        this.subjectLine = '';
        this.name = true;
        this.email = false;
        this.emailOptional = true;
        this.phone = true;
        this.optionalTxt = '';
        this.desc = '';
        this.btnClass = 'btn btn-primary';
        this.resetButton = false;
        break;
      case 'col-21':
        //this.TwoColumns=true;
        this.className = 'height-250 padding-0-10';
        this.title = 'Send Your Feedback';
        this.sendButton = 'Submit';
        this.placeholder = 'Write us a message...';
        this.background = '';
        this.color = '';
        this.flushed = true;
        this.enableReset = false;
        this.sendLabel = '';
        // this.inputColor = '';
        this.inputBack = '';
        this.labelColor = '';
        this.replyChecked = false;
        this.emailCheckbox = true;
        this.sendEmail = '';
        this.replyOption = '';
        this.subjectLine = '';
        this.name = true;
        this.email = false;
        this.emailOptional = true;
        this.phone = true;
        this.optionalTxt = '';
        this.desc = '';
        this.btnClass = 'btn btn-primary';
        this.resetButton = false;
        break;
      case 'col-2-1-2':
        //this.TwoColumns=true;
        this.className = 'height-250 padding-0-10';
        this.title = 'Send Your Feedback';
        this.sendButton = 'Submit';
        this.placeholder = 'Write us a message...';
        this.background = '';
        this.color = '';
        this.flushed = true;
        this.enableReset = false;
        this.sendLabel = '';
        //this.inputColor = '';
        this.inputBack = '';
        this.labelColor = '';
        this.replyChecked = false;
        this.emailCheckbox = true;
        this.sendEmail = '';
        this.replyOption = '';
        this.subjectLine = '';
        this.name = true;
        this.email = false;
        this.emailOptional = true;
        this.phone = true;
        this.optionalTxt = '';
        this.desc = '';
        this.btnClass = 'btn btn-primary';
        this.resetButton = false;
        break;
      case 'col-2-1-3':
        //this.TwoColumns=true;
        this.className = 'height-250 padding-0-10';
        this.title = 'Send Your Feedback';
        this.sendButton = 'Submit';
        this.placeholder = 'Write us a message...';
        this.background = '';
        this.color = '';
        this.flushed = true;
        this.enableReset = false;
        this.sendLabel = '';
        //this.inputColor = '';
        this.inputBack = '';
        this.labelColor = '';
        this.replyChecked = false;
        this.emailCheckbox = true;
        this.sendEmail = '';
        this.replyOption = '';
        this.subjectLine = '';
        this.name = true;
        this.email = false;
        this.emailOptional = true;
        this.phone = true;
        this.optionalTxt = '';
        this.desc = '';
        this.btnClass = 'btn btn-primary';
        this.resetButton = false;
        break;
      case 'col-2-2-1':
        //this.TwoColumns=true;
        this.className = 'height-250 padding-0-10';
        this.title = 'Send Your Feedback';
        this.sendButton = 'Submit';
        this.placeholder = 'Write us a message...';
        this.background = '';
        this.color = '';
        this.flushed = true;
        this.enableReset = false;
        this.sendLabel = '';
        //this.inputColor = '';
        this.inputBack = '';
        this.labelColor = '';
        this.replyChecked = false;
        this.emailCheckbox = true;
        this.sendEmail = '';
        this.replyOption = '';
        this.subjectLine = '';
        this.name = true;
        this.email = false;
        this.emailOptional = true;
        this.phone = true;
        this.optionalTxt = '';
        this.desc = '';
        this.btnClass = 'btn btn-primary';
        this.resetButton = false;
        break;
      case 'col-2-3-1':
        //this.TwoColumns=true;
        this.className = 'height-250 padding-0-10';
        this.title = 'Send Your Feedback';
        this.sendButton = 'Submit';
        this.placeholder = 'Write us a message...';
        this.background = '';
        this.color = '';
        this.flushed = true;
        this.enableReset = false;
        this.sendLabel = '';
        //this.inputColor = '';
        this.inputBack = '';
        this.labelColor = '';
        this.replyChecked = false;
        this.emailCheckbox = true;
        this.sendEmail = '';
        this.replyOption = '';
        this.subjectLine = '';
        this.name = true;
        this.email = false;
        this.emailOptional = true;
        this.phone = true;
        this.optionalTxt = '';
        this.desc = '';
        this.btnClass = 'btn btn-primary';
        this.resetButton = false;
        break;
      case 'col-31':
        //this.ThreeColumns=true;
        this.className = 'height-200 padding-0';
        this.title = 'Send Your Feedback';
        this.sendButton = 'Submit';
        this.placeholder = 'Write us a message...';
        this.background = '';
        this.color = '';
        this.flushed = true;
        this.enableReset = false;
        this.sendLabel = '';
        //this.inputColor = '';
        this.inputBack = '';
        this.labelColor = '';
        this.replyChecked = false;
        this.emailCheckbox = true;
        this.sendEmail = '';
        this.replyOption = '';
        this.subjectLine = '';
        this.name = true;
        this.email = false;
        this.emailOptional = true;
        this.phone = true;
        this.optionalTxt = '';
        this.desc = '';
        this.btnClass = 'btn btn-primary';
        this.resetButton = false;
        break;
      case 'col-3-1-1-2':
        //this.ThreeColumns=true;
        this.className = 'height-200 padding-0';
        this.title = 'Send Your Feedback';
        this.sendButton = 'Submit';
        this.placeholder = 'Write us a message...';
        this.background = '';
        this.color = '';
        this.flushed = true;
        this.enableReset = false;
        this.sendLabel = '';
        //this.inputColor = '';
        this.inputBack = '';
        this.labelColor = '';
        this.replyChecked = false;
        this.emailCheckbox = true;
        this.sendEmail = '';
        this.replyOption = '';
        this.subjectLine = '';
        this.name = true;
        this.email = false;
        this.emailOptional = true;
        this.phone = true;
        this.optionalTxt = '';
        this.desc = '';
        this.btnClass = 'btn btn-primary';
        this.resetButton = false;
        break;
      case 'col-3-1-2-1':
        //this.ThreeColumns=true;
        this.className = 'height-200 padding-0';
        this.title = 'Send Your Feedback';
        this.sendButton = 'Submit';
        this.placeholder = 'Write us a message...';
        this.background = '';
        this.color = '';
        this.flushed = true;
        this.enableReset = false;
        this.sendLabel = '';
        //this.inputColor = '';
        this.inputBack = '';
        this.labelColor = '';
        this.replyChecked = false;
        this.emailCheckbox = true;
        this.sendEmail = '';
        this.replyOption = '';
        this.subjectLine = '';
        this.name = true;
        this.email = false;
        this.emailOptional = true;
        this.phone = true;
        this.optionalTxt = '';
        this.desc = '';
        this.btnClass = 'btn btn-primary';
        this.resetButton = false;
        break;
      case 'col-3-2-1-1':
        //this.ThreeColumns=true;
        this.className = 'height-200 padding-0';
        this.title = 'Send Your Feedback';
        this.sendButton = 'Submit';
        this.placeholder = 'Write us a message...';
        this.background = '';
        this.color = '';
        this.flushed = true;
        this.enableReset = false;
        this.sendLabel = '';
        //this.inputColor = '';
        this.inputBack = '';
        this.labelColor = '';
        this.replyChecked = false;
        this.emailCheckbox = true;
        this.sendEmail = '';
        this.replyOption = '';
        this.subjectLine = '';
        this.name = true;
        this.email = false;
        this.emailOptional = true;
        this.phone = true;
        this.optionalTxt = '';
        this.desc = '';
        this.btnClass = 'btn btn-primary';
        this.resetButton = false;
        break;
      case 'col-42':
        //this.FourColumns=true;
        this.className = 'height-200 padding-0';
        this.title = 'Send Your Feedback';
        this.sendButton = 'Submit';
        this.placeholder = 'Write us a message...';
        this.background = '';
        this.color = '';
        this.flushed = true;
        this.enableReset = false;
        this.sendLabel = '';
        //this.inputColor = '';
        this.inputBack = '';
        this.labelColor = '';
        this.replyChecked = false;
        this.emailCheckbox = true;
        this.sendEmail = '';
        this.replyOption = '';
        this.subjectLine = '';
        this.name = true;
        this.email = false;
        this.emailOptional = true;
        this.phone = true;
        this.optionalTxt = '';
        this.desc = '';
        this.btnClass = 'btn btn-primary';
        this.resetButton = false;
        break;
      case 'col-421':
        //this.FourColumns=true;
        this.className = 'height-200 padding-0';
        this.title = 'Send Your Feedback';
        this.sendButton = 'Submit';
        this.placeholder = 'Write us a message...';
        this.background = '';
        this.color = '';
        this.flushed = true;
        this.enableReset = false;
        this.sendLabel = '';
        //this.inputColor = '';
        this.inputBack = '';
        this.labelColor = '';
        this.replyChecked = false;
        this.emailCheckbox = true;
        this.sendEmail = '';
        this.replyOption = '';
        this.subjectLine = '';
        this.name = true;
        this.email = false;
        this.emailOptional = true;
        this.phone = true;
        this.optionalTxt = '';
        this.desc = '';
        this.btnClass = 'btn btn-primary';
        this.resetButton = false;
        break;
      case 'col-51':
        //this.FiveColumns=true;
        this.className = 'height-200 padding-0';
        this.title = 'Send Your Feedback';
        this.sendButton = 'Submit';
        this.placeholder = 'Write us a message...';
        this.background = '';
        this.color = '';
        this.flushed = true;
        this.enableReset = false;
        this.sendLabel = '';
        //this.inputColor = '';
        this.inputBack = '';
        this.labelColor = '';
        this.replyChecked = false;
        this.emailCheckbox = true;
        this.sendEmail = '';
        this.replyOption = '';
        this.subjectLine = '';
        this.name = true;
        this.email = false;
        this.emailOptional = true;
        this.phone = true;
        this.optionalTxt = '';
        this.desc = '';
        this.btnClass = 'btn btn-primary';
        this.resetButton = false;
        break;
      case 'col-632':
        //this.SixColumns=true;
        this.className = 'height-200 padding-0';
        this.title = 'Send Your Feedback';
        this.sendButton = 'Submit';
        this.placeholder = 'Write us a message...';
        this.background = '';
        this.color = '';
        this.flushed = true;
        this.enableReset = false;
        this.sendLabel = '';
        //this.inputColor = '';
        this.inputBack = '';
        this.labelColor = '';
        this.replyChecked = false;
        this.emailCheckbox = true;
        this.sendEmail = '';
        this.replyOption = '';
        this.subjectLine = '';
        this.name = true;
        this.email = false;
        this.emailOptional = true;
        this.phone = true;
        this.optionalTxt = '';
        this.desc = '';
        this.btnClass = 'btn btn-primary';
        this.resetButton = false;
        break;
      default:
        this.className = 'padding-25';
        this.title = 'Send Your Feedback';
        this.sendButton = 'Submit';
        this.emailCheckbox = true;
        this.placeholder = 'Write us a message...';
        this.background = '';
        this.color = '';
        this.flushed = true;
        this.enableReset = false;
        this.sendLabel = '';
        //this.inputColor = '';
        this.inputBack = '';
        this.labelColor = '';
        this.replyChecked = false;
        this.emailCheckbox = true;
        this.sendEmail = '';
        this.replyOption = '';
        this.subjectLine = '';
        this.name = true;
        this.email = false;
        this.emailOptional = true;
        this.phone = true;
        this.optionalTxt = '';
        this.desc = '';
        this.btnClass = 'btn btn-primary';
        this.resetButton = false;
    }
  }
  getFormVariables() {
    // Form Variables
    this.typeOf = 'feedback'; // we force now to cta
    this.title = this._temp[this.compArray].title;
    this.background = this._temp[this.compArray].background;
    this.color = this._temp[this.compArray].color;
    this.flushed = this._temp[this.compArray].flushed;
    this.className = this._temp[this.compArray].className;
    this.enableReset = this._temp[this.compArray].enableReset;
    this.sendLabel = this._temp[this.compArray].sendLabel;
    //this.inputColor = this.temp[ this.compArray ].inputColor;
    this.inputBack = this._temp[this.compArray].inputBack;
    this.labelColor = this._temp[this.compArray].labelColor;
    this.replyChecked = this._temp[this.compArray].replyChecked;
    this.emailCheckbox = this._temp[this.compArray].emailCheckbox;
    this.sendEmail = this._temp[this.compArray].sendEmail;
    this.replyOption = this._temp[this.compArray].replyOption;
    this.subjectLine = this._temp[this.compArray].subjectLine;
    this.name = this._temp[this.compArray].name;
    this.email = this._temp[this.compArray].email;
    this.emailOptional = this._temp[this.compArray].emailOptional;
    this.phone = this._temp[this.compArray].phone;
    this.optionalTxt = this._temp[this.compArray].optionalTxt;
    this.desc = this._temp[this.compArray].desc;
    this.sendButton = this._temp[this.compArray].sendButton;
    this.btnClass = this._temp[this.compArray].btnClass;
    this.resetButton = this._temp[this.compArray].resetButton;
    this.placeholder = this._temp[this.compArray].placeholder;
  }
  setRowType() {
    // Just in case values are null, pre-populate to conform to row.
    switch (this.rowType) {
      case 'col-2':
        //this.TwoColumns=true;
        this.className = 'height-250 padding-0-10';
        break;
      case 'col-21':
        //this.TwoColumns=true;
        this.className = 'height-250 padding-0-10';
        break;
      case 'col-2-1-2':
        // this.TwoColumns=true;
        this.className = 'height-250 padding-0-10';
        break;
      case 'col-2-1-3':
        //this.TwoColumns=true;
        this.className = 'height-250 padding-0-10';
        break;
      case 'col-2-2-1':
        //this.TwoColumns=true;
        this.className = 'height-250 padding-0-10';
        break;
      case 'col-2-3-1':
        //this.TwoColumns=true;
        this.className = 'height-250 padding-0-10';
        break;
      case 'col-31':
        //this.ThreeColumns=true;
        this.className = 'height-200 padding-0-10';
        break;
      case 'col-3-1-1-2':
        //this.ThreeColumns=true;
        this.className = 'height-200 padding-0-10';
        break;
      case 'col-3-1-2-1':
        //this.ThreeColumns=true;
        this.className = 'height-250 padding-0-10';
        break;
      case 'col-3-2-1-1':
        //this.ThreeColumns=true;
        this.className = 'height-200 padding-0-10';
        break;
      case 'col-42':
        //this.FourColumns=true;
        this.className = 'height-200 padding-0-10';
        break;
      case 'col-421':
        //this.FourColumns=true;
        this.className = 'height-200 padding-0-10';
        break;
      case 'col-51':
        //this.FiveColumns=true;
        this.className = 'height-200 padding-0-10';
        break;
      case 'col-632':
        //this.SixColumns=true;
        this.className = 'height-200 padding-0-10';
        break;
      default:
        //this.OneColumn = true;
        this.className = 'padding-25';
    }
  }

  updateFEED(feed) {
    const result = {
      typeOf: this.typeOf,
      title: this.title,
      background: this.background,
      color: this.color,
      flushed: this.flushed,
      className: this.className,
      enableReset: this.enableReset,
      emailCheckbox: this.emailCheckbox,
      sendLabel: this.sendLabel,
      //'inputColor' : this.inputColor,
      inputBack: this.inputBack,
      labelColor: this.labelColor,
      replyChecked: this.replyChecked,
      sendEmail: this.sendEmail,
      replyOption: this.replyOption,
      subjectLine: this.subjectLine,
      name: this.name,
      email: this.email,
      sendButton: this.sendButton,
      btnClass: this.btnClass,
      resetButton: this.resetButton,
      placeholder: this.placeholder,
      emailOptional: this.emailOptional,
      phone: this.phone,
      optionalTxt: this.optionalTxt,
      desc: this.desc,
    };
    this._editService.setFEEDBACK(result, this.rowType, this._temp, this.rowArray, this.compArray);
  }
  submitFEED(feed) {
    const result = {
      typeOf: this.typeOf,
      title: this.title,
      background: this.background,
      color: this.color,
      flushed: this.flushed,
      className: this.className,
      enableReset: this.enableReset,
      emailCheckbox: this.emailCheckbox,
      sendLabel: this.sendLabel,
      //'inputColor' : this.inputColor,
      inputBack: this.inputBack,
      labelColor: this.labelColor,
      replyChecked: this.replyChecked,
      sendEmail: this.sendEmail,
      replyOption: this.replyOption,
      subjectLine: this.subjectLine,
      name: this.name,
      email: this.email,
      sendButton: this.sendButton,
      btnClass: this.btnClass,
      resetButton: this.resetButton,
      placeholder: this.placeholder,
      emailOptional: this.emailOptional,
      phone: this.phone,
      optionalTxt: this.optionalTxt,
      desc: this.desc,
    };
    let keepGoing = true;
    let message = '';
    const emailregex =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // eslint-disable-line

    //
    // ONLY COMMA SEPARATED EMAILS ARE ALLOWED, NO SEMICOLONS ALLOWED
    //

    if (this.sendEmail.includes(',')) {
      // multiple email addresses
      const message = 'enter valid send to email addresses';
      const email_arr = this.sendEmail.split(',');
      if (!email_arr) {
        keepGoing = false;
        this.openSnackBar(message, 'ok');
      } else {
        if (email_arr.length <= 0) {
          keepGoing = false;
          this.openSnackBar(message, 'ok');
        }
        if (email_arr.length > 0) {
          for (let index = 0; index < email_arr.length; index++) {
            const em = email_arr[index];
            if (!emailregex.test(em.trim())) {
              keepGoing = false;
              this.openSnackBar(message, 'ok');
              break;
            }
          }
        }
      }
    } else if (!emailregex.test(this.sendEmail)) {
      // only one email address added
      keepGoing = false;
      message += 'enter a valid send to email address';
      this.openSnackBar(message, 'ok');
    }
    if (keepGoing) {
      this._editService.setFEEDBACK(
        result,
        this.rowType,
        this._temp,
        this.rowArray,
        this.compArray,
      );
      this.closeNav();
    }
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 5000,
      verticalPosition: 'top',
    });
  }
}
